// PDP variations — size/color picker + qty +/- sync z WC variations.
// Czyta `data-product_variations` (JSON z available_variations Woo) i wyznacza variation_id
// po wybraniu wszystkich atrybutów. Ustawia hidden inputs `attribute_*` + `variation_id`,
// enable/disable głównego ATC. Działa też na simple products (qty controls).

function readVariations(form) {
  const raw = form.getAttribute('data-product_variations');
  if (!raw) return [];
  try { return JSON.parse(raw); } catch (e) { return []; }
}

function variantMatch(variations, state) {
  return variations.find((v) => {
    return Object.entries(v.attributes).every(([key, val]) => {
      const cleanKey = key.replace(/^attribute_/, '');
      // pa_rozmiar => state key "pa_rozmiar"
      const stateVal = state[cleanKey];
      if (!val) return true; // wariacja akceptuje wszystko dla tego atrybutu
      if (!stateVal) return false;
      return String(stateVal).toLowerCase() === String(val).toLowerCase();
    });
  });
}

function setSwatchActive(btn, active) {
  if (btn.classList.contains('rounded-full')) {
    // color swatch — outline ring
    btn.style.boxShadow = active ? '0 0 0 2px #0d0d0d, 0 0 0 4px #fff inset' : '';
  } else {
    if (active) {
      btn.classList.add('border-black');
      btn.classList.remove('hairline');
    } else {
      btn.classList.remove('border-black');
      btn.classList.add('hairline');
    }
  }
}

function initVariableForm(form) {
  const variations = readVariations(form);
  const state = {};
  const variationInput = form.querySelector('[data-variation-id]');
  const submitBtn = form.querySelector('#main-add-to-cart');
  const buyNowBtn = form.querySelector('[data-buy-now]');
  const priceEl = document.querySelector('.product-price');
  const initialPriceHTML = priceEl ? priceEl.innerHTML : '';

  function refresh() {
    const match = variantMatch(variations, state);
    if (variationInput) variationInput.value = match ? match.variation_id : '';
    const allChosen = Array.from(form.querySelectorAll('[data-attr-input]')).every((i) => i.value !== '');
    const canBuy = !!(match && match.is_in_stock && match.is_purchasable && allChosen);
    if (submitBtn) {
      submitBtn.disabled = !canBuy;
    }
    if (buyNowBtn) {
      buyNowBtn.disabled = !canBuy;
    }
    form.querySelectorAll('[data-express-pay]').forEach((b) => { b.disabled = !canBuy; });
    if (priceEl && match && match.price_html) {
      priceEl.innerHTML = match.price_html;
    } else if (priceEl && !allChosen) {
      priceEl.innerHTML = initialPriceHTML;
    }
  }

  form.querySelectorAll('[data-attr-pick]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const attr = btn.getAttribute('data-attr-pick');
      const val = btn.getAttribute('data-attr-value');
      state[attr] = val;

      // visual state
      form.querySelectorAll(`[data-attr-pick="${CSS.escape(attr)}"]`).forEach((b) => setSwatchActive(b, b === btn));

      // hidden input
      const input = form.querySelector(`[data-attr-input="${CSS.escape(attr)}"]`);
      if (input) input.value = val;

      // label
      const labelEl = form.querySelector(`[data-attr-current="${CSS.escape(attr)}"]`);
      if (labelEl) labelEl.textContent = val.charAt(0).toUpperCase() + val.slice(1);

      refresh();
    });
  });

  // Rozmiar renderujemy jako <select> (patrz variable.php) — select jest jednocześnie
  // polem formularza, więc wystarczy spiąć jego zmianę ze stanem wariantu.
  form.querySelectorAll('[data-attr-select]').forEach((sel) => {
    sel.addEventListener('change', () => {
      const attr = sel.getAttribute('data-attr-select');
      state[attr] = sel.value;
      const labelEl = form.querySelector(`[data-attr-current="${CSS.escape(attr)}"]`);
      if (labelEl) {
        labelEl.textContent = sel.value ? sel.value.charAt(0).toUpperCase() + sel.value.slice(1) : '—';
      }
      refresh();
    });
  });

  // initial — no selection
  refresh();
}

function initQtyControls(scope) {
  scope.querySelectorAll('[data-kb-qty]').forEach((grp) => {
    if (grp.__kbQtyBound) return;
    grp.__kbQtyBound = true;
    const inp = grp.querySelector('[data-qty-input]');
    if (!inp) return;
    const max = inp.getAttribute('max');
    const maxVal = max ? parseInt(max, 10) : Infinity;
    const min = parseInt(inp.getAttribute('min') || '1', 10);

    grp.querySelector('[data-qty-inc]')?.addEventListener('click', () => {
      const cur = parseInt(inp.value, 10) || 0;
      inp.value = String(Math.min(maxVal, cur + 1));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
    grp.querySelector('[data-qty-dec]')?.addEventListener('click', () => {
      const cur = parseInt(inp.value, 10) || 0;
      inp.value = String(Math.max(min, cur - 1));
      inp.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
}

function initPDPVariations() {
  // Variable products
  document.querySelectorAll('form.variations_form').forEach((form) => {
    if (form.__kbInited) return;
    form.__kbInited = true;
    initVariableForm(form);
  });
  // Qty controls (simple + variable — header-bar style + variant)
  initQtyControls(document);
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initPDPVariations();
  else document.addEventListener('DOMContentLoaded', initPDPVariations);
}

export {};
